import PageContext from '@bingads-webui-static-legacy/page-context';

export function getCommonCampaignCreationViewOptions(props) {
  const {
    serverContext: {
      CurrentAccount: {
        CurrencyCode,
      },
      CurrentAccountInActive,
      Permissions: {
        IsReadOnlyUser,
        IsImpressionTrackingUrlsEnabled,
      },
    },
    perfMarker,
    i18n,
  } = props;

  return {
    viewContext: {
      accountCurrencyCode: CurrencyCode,
      isReadOnlyUser: IsReadOnlyUser,
      CurrentAccountInActive,
    },
    perfMarker,
    isForVNext: true,
    isImpressionTrackingUrlsEnabled: IsImpressionTrackingUrlsEnabled,
    newI18n: i18n,
    deps: {
      pageContext: PageContext,
    },
  }
}
